/** Central query-key factory so invalidation stays consistent across features. */
export const queryKeys = {
  auth: { me: ['auth', 'me'] as const },
  domains: {
    all: ['domains'] as const,
    list: (params: Record<string, unknown>) => ['domains', 'list', params] as const,
    detail: (id: string) => ['domains', 'detail', id] as const,
  },
  mailboxes: {
    all: ['mailboxes'] as const,
    list: (params: Record<string, unknown>) => ['mailboxes', 'list', params] as const,
    detail: (id: string) => ['mailboxes', 'detail', id] as const,
  },
  queue: { summary: ['queue', 'summary'] as const },
  health: { ready: ['health', 'ready'] as const },
  statistics: { overview: (windowHours: number) => ['statistics', windowHours] as const },
  search: (term: string) => ['search', term] as const,
};
